module.exports = __webpack_public_path__ + "img/IMAGE0007.20fc7eda.jpg";